export const REDUCER_NAME = 'CHARTS'

